<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-08 15:26:53
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-24 11:23:11
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/enterprise_home_page/index.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <!-- -->
    <bannerCard :detail='nowHomepageInfo'></bannerCard>

    <div class="containerBox" style="overflow:hidden;">
      <swiper ref="mySwiper" @slideChange="swiperChange" :options="option" class="home-medical-box">
        <swiper-slide class="benefitBox" v-for="(item, index) in homepageArr" :key="index">
          <div :id="'ele'+index">
            <MainCard @refresh='refresh' @wxshare='wxshare' :language='language' :detail='nowHomepageInfo' @contactUs="contactUs"></MainCard>
          </div>
        </swiper-slide>
      </swiper>

      <!-- <van-swipe class="my-swiper" ref='mySwiper' :loop='false' :show-indicators='false' @change="swiperChange">
        <van-swipe-item v-for="(item, index) in homepageArr">
              
        </van-swipe-item>
      </van-swipe> -->

      <div class="controll">
        <div class="btn" @click="goProduct">
          <i class="iconfont icon">{{`\ue775`}}</i>
          <p>{{$t('lang.t252')}}</p>
        </div>
        <div class="btn" @click="goGroup">
          <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/team.png" alt="">
          <p>{{$t('lang.t253')}}</p>
        </div>
      </div>
    </div>

    <div style="position: relative;top: -17px;">
      <MainPageIntroduction :detail='nowHomepageInfo' :photoList='photoList'></MainPageIntroduction>
    </div>

    <vistorLinkUsPopVue ref="visitorLinkRef" :shareParams='shareParams' :enterpriseCode='enterpriseCode' :language='language' :company='nowHomepageInfo.enterpriseName' :source='nowHomepageInfo.enterpriseName'></vistorLinkUsPopVue>
    <img class="aigc" @click="goAigc" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/rabot2.gif" alt="">
    <sharePop ref="sharePop"></sharePop>
  </div>
</template>

<script>
import bannerCard from './components/bannerCard.vue'
import MainCard from './components/card.vue'
import MainPageIntroduction from './components/MainPageIntroduction.vue'
import { handleSenceQrCode, queryEnterPriseHomePage, queryEnterPriseHomePageLanguage, photoAlbumQuery, queryContactInfoByType, enterpriseAddClue, enterpriseQuerySearchType } from '@/api/interNational'
import { GetQueryString } from '@/utils/utils'
import vistorLinkUsPopVue from '@/components/vistorLinkUsPop.vue'
import sharePop from '@/components/sharePop.vue'
export default {
  name: 'index',
  components: { bannerCard, MainCard, MainPageIntroduction, vistorLinkUsPopVue, sharePop },
  data() {
    return {
      enterpriseCode: '',
      language: '',
      nowHomepageInfo: {},
      photoList: [],
      homepageArr: [],
      initialSwipeIndex: 0,
      isInit: false,
      swiperEleHeight: 0,
      productName:'',
      productIcon:'',
      option: {
        slidesPerView: 1, //显示slide的数量
        centeredSlides: false, //居中显示
        loop: true, //循环
        initialSlide: 0, //初始索引
        spaceBetween: 5, //间距
      },
      languageList: [
        { name: '中文', languageName: '中文', languageKey: 'CN', check: false },
        { name: '英语', languageName: 'English', languageKey: 'EN', check: false },
        { name: '法语', languageName: 'Français', languageKey: 'FR', check: false },
        { name: '俄语', languageName: 'Русский', languageKey: 'RU', check: false },
        { name: '西班牙语', languageName: 'Español', languageKey: 'ES', check: false },
        { name: '日语', languageName: '日本語', languageKey: 'JA', check: false },
        { name: '韩语', languageName: '한국어', languageKey: 'KO', check: false },
        { name: '印度尼西亚语', languageName: 'Bahasa Indonesia', languageKey: 'ID', check: false },
        { name: '越南语', languageName: 'Tiếng Việt', languageKey: 'VI', check: false },
        { name: '德语', languageName: 'Deutsch', languageKey: 'DE', check: false },
        { name: '土耳其语', languageName: 'Türkçe', languageKey: 'TR', check: false },
        { name: '意大利语', languageName: 'Italiano', languageKey: 'IT', check: false },
        { name: '葡萄牙语', languageName: 'Português', languageKey: 'PT', check: false },
        { name: '泰语', languageName: 'ภาษาไทย', languageKey: 'TH', check: false },
        { name: '马来语', languageName: 'Bahasa Melayu', languageKey: 'MS', check: false },
        { name: '阿拉伯语', languageName: 'بالعربية', languageKey: 'AR', check: false },
      ],
      shareParams: {},
    }
  },

  mounted() {
    this.senceKey = GetQueryString(`scenesKey`)
    this.enterpriseCode = GetQueryString(`enterpriseCode`)
    this.language = GetQueryString(`language`) || 'CN'
    if (this.enterpriseCode) {
      this.queryEnterpriseHomePage()
      this.$eventBus.$emit('changeLocaelLanguage', { languageKey: this.language })
      // this.getTabIcon()
    } else {
      handleSenceQrCode({}, this.senceKey).then((res) => {
        let params = JSON.parse(res.data.params)
        console.log(params)
        this.enterpriseCode = params.enterpriseCode
        this.language = params.language
        this.shareParams = params
        // this.getTabIcon()
        this.queryEnterpriseHomePage()
        this.$eventBus.$emit('changeLocaelLanguage', { languageKey: params.language })
      })
    }

    this.$eventBus.$on('refreshLocael', (res) => {
      console.log('我出发了 2222')
      this.oldLanguage = this.language
      this.language = res.lang
      this.isInit = false
      this.queryEnterpriseHomePage(true)
    })
    document.title = this.$t('lang.t217')
  },
  watch: {
    // homepageArr:{
    //   handler() {
    //     this.getSwiperHeight()
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  methods: {
    wxshare() {
      this.$refs.sharePop.open()
    },
    getSwiperHeight() {
      let length = this.homepageArr.length
      if (length) {
        this.$nextTick(() => {
          this.homepageArr.map((item, index) => {
            let myElement = `ele${index}`
            console.log('myElement', myElement)
            let rect = document.getElementById(myElement)
            console.log('rect', rect)
            let height = rect.offsetHeight
            console.log('height', height)
            this.$set(this.homepageArr[index], 'height', height)
            console.log(this.homepageArr)
            this.swiperEleHeight = height + 30
          })
        })
      } else {
        this.swiperEleHeight = 150 + 30
      }
    },
    refresh() {
      this.queryDetail(this.language)
    },
    getTabIcon(){
      enterpriseQuerySearchType({}, { enterpriseCode: this.enterpriseCode, language: this.language }).then((res) => {
        let data = res.data
        this.productName = data.title || '产品'
        this.productIcon = data.icon || 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/productIcon.png'
      })
    },
    async contactUs() {
      let params = {
        type: 'ENTERPRISES',
        code: this.enterpriseCode,
        language: this.language,
      }
      const { data } = await queryContactInfoByType({}, params)
      console.log(data)
      this.$refs.visitorLinkRef.open(data)
    },
    goGroup() {
      this.$router.push({ path: '/mini-h5/index/group', query: { enterpriseCode: this.enterpriseCode, language: this.language } })
    },
    goProduct() {
      this.$router.push({ path: '/mini-h5/index/productList', query: { enterpriseCode: this.enterpriseCode, language: this.language } })
    },
    swiperChange() {
      let index = this.$refs.mySwiper.swiper.realIndex
      console.log(index, this.homepageArr[index].language)

      this.language = this.homepageArr[index].language
      this.queryDetail()
      // this.getTabIcon()
      // this.swiperEleHeight()
    },
    async queryEnterpriseHomePage(isRefresh) {
      try {
        const { data: homepageArr } = await queryEnterPriseHomePageLanguage({}, { enterpriseCode: this.enterpriseCode })
        this.homepageArr = homepageArr

        // 增加留资判断
        if (isRefresh) {
          let list = this.homepageArr.filter((v) => {
            return v.language == this.language
          })
          if (list.length > 0) {
            this.$toast(this.$t('lang.t321'))
          } else {
            this.$toast(this.$t('lang.t320'))
            this.$isLogin(true)
              .then(async (res) => {
                console.log('我出发了 1111')
                let languageWord = this.languageList.filter((v) => v.languageKey == this.language)
                // let params = {
                //   sourceType: 'H5_SOURCE',
                //   content: `需要AI荟客厅翻译${languageWord[0].name}`,
                //   enterpriseCode: this.enterpriseCode,
                //   channel: 'ENTERPRISE_NO_LANGUAGE',
                //   source: this.homepageArr[0].enterpriseName,
                // }
                // await enterpriseAddClue({}, params)
                this.language = this.oldLanguage
              })
              .catch((err) => {
                this.language = this.oldLanguage
              })
          }
        }

        const { data: nowHomepage } = await queryEnterPriseHomePage({}, { enterpriseCode: this.enterpriseCode, language: this.language })
        nowHomepage.newsIntroduction = !!nowHomepage.newsIntroduction ? JSON.parse(nowHomepage.newsIntroduction) : []
        this.photoWallQuery()

        console.log(nowHomepage, '------,,,,,,,,')
        this.nowHomepageInfo = nowHomepage
        this.initialSwipeIndex = this.homepageArr.findIndex((v) => v.language == this.language)
        if (!this.isInit) {
          this.$nextTick(() => {
            console.log(this.$refs.mySwiper.swiper.realIndex)
            this.$refs.mySwiper.swiper.slideTo(this.initialSwipeIndex)
            this.isInit = true
          })
        }
        let tokenFlag = localStorage.getItem('token')
        console.log(tokenFlag)
        if (tokenFlag) {
          let params1 = {
            sourceType: 'H5_SOURCE',
            enterpriseCode: this.enterpriseCode,
            channel: 'SCAN_ENTERPRISE_QRCODE',
            source: this.homepageArr[0].enterpriseName,
          }
          await enterpriseAddClue({}, params1)
        }
      } catch (err) {
        console.log(err, '====>>>')
      }
    },
    async queryDetail() {
      try {
        const { data: nowHomepage } = await queryEnterPriseHomePage({}, { enterpriseCode: this.enterpriseCode, language: this.language })
        nowHomepage.newsIntroduction = !!nowHomepage.newsIntroduction ? JSON.parse(nowHomepage.newsIntroduction) : []
        this.photoWallQuery()

        this.nowHomepageInfo = nowHomepage
      } catch (err) {
        console.log(err, '====>>>')
      }
    },
    goAigc() {
      let token = localStorage.getItem('token')
      location.href = `${process.env.VUE_APP_H5_BASE_URL}/#/aigc?appKey=WX_MINI_WEMEET&sourceId=${this.nowHomepageInfo.enterpriseCode}&sourceType=enterprise&sourceName=${this.nowHomepageInfo.enterpriseName}&language=${this.language}&token=${token ? token : ''}`
    },

    async photoWallQuery() {
      this.photoList = []
      const { data } = await photoAlbumQuery(
        {},
        {
          enterpriseCode: this.enterpriseCode,
          type: 'PHOTO',
        }
      )
      console.log(data)
      this.photoList = data
    },
  },
}
</script>


<style lang='less'>
.containerBox {
  .van-swipe {
    overflow: hidden;
    .van-swipe-item {
      transform: scale(0.98);
    }
  }
}
</style>

<style lang="less" scoped>
.aigc {
  position: fixed;
  bottom: 60px;
  right: 10px;
  width: 100px;
  height: 100px;
}
.containerBox {
  padding: 0 12px;
  position: relative;
  top: -30px;

  .controll {
    width: 100%;
    height: 70px;
    background: #fff;
    border-radius: 10px;
    margin-top: 11px;
    display: flex;
    justify-content: space-around;
    .btn {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .icon {
        font-size: 24px;
      }
      img {
        width: 26px;
        height: 26px;
      }
      .name {
        color: #9e9e9e;
        font-size: 11px;
        margin-top: 5px;
      }
    }
  }
}
</style>